import * as React from 'react';
import eaiws = egr.wcf.eaiws;
import { LayoutType } from '../../../constants/LayoutConstants';
import { CenteredImage } from '../../CenteredImage';
import { CatalogLabel } from './CatalogLabel';

interface CatalogItemProps {
    anchor: string | null;
    catalog: eaiws.catalog.CatalogItem;
    catalogItem: eaiws.catalog.CatalogItem;
    clickHandler: (item: eaiws.catalog.CatalogItem) => void;
    addSpacer: boolean;
    layoutType: LayoutType;
}

export class CatalogItem extends React.Component<CatalogItemProps, {}> {
    public render(): JSX.Element | null {
        let label: string = this.props.catalogItem.label;
        if (label == null || label === '') {
            label = this.props.catalogItem.name;
        }
        let catalogName: string = '';
        let tType: string = 'itemtype-catalog';
        if (this.props.catalog) {
            catalogName = this.props.catalog.label;
            switch (this.props.catalogItem.type) {
                case 'Article':
                case 'Container':
                    tType = 'itemtype-article';
                    break;
                default:
                    tType = 'itemtype-folder';
                    break;
            }
        }
        const catalogTile: boolean = tType === 'itemtype-catalog';
        return (
            <div
                className={'catalog-item-container' + (catalogTile ? ' catalog-tile' : '')}
                onClick={this.onClick}
                id={this.props.anchor ? this.props.anchor + '-catalogitem' : ''}
            >
                {this.props.addSpacer ? <div className="catalog-list-spacer"/> : null}
                <div className={'catalog-item ' + tType}>
                    {this.getImageElement()}
                    <CatalogLabel catalog={this.props.catalog} catalogName={catalogName} label={label}/>
                </div>
                <CatalogLabel catalog={this.props.catalog} catalogName={catalogName} label={label}/>
            </div>
        );
    }

    protected getImageElement = (): JSX.Element => {
        if (false) {
            if (this.props.catalogItem.icon != null && this.props.catalogItem.icon !== '') {
                return <CenteredImage className="button-image" src={this.props.catalogItem.icon} />;
            }
            return <div className="button-image dummy-image"/>;
        }
        if (this.props.catalogItem.icon != null && this.props.catalogItem.icon !== '') {
            return <div className="catalog-item-image"><CenteredImage className="" src={this.props.catalogItem.icon} /></div>;
        }
        return <div className="catalog-item-image dummy-image"/>;
    };

    protected onClick = (): void => {
        if (this.props.clickHandler != null) {
            this.props.clickHandler(this.props.catalogItem);
        }
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/sidebar/catalog/CatalogItem.tsx